<template>
  <v-bottom-sheet
    :key="render"
    v-model="showMessage"
    inset
    max-width="50%"
    @click:outside="close()"
    class="a-message-sheet"
  >
    <v-alert
      :type="messageType"
      rounded
      dense
      class="a-message-sheet messageSheet"
      v-if="isMeetingUpdatedMsgDeletedDoc"
    >
      <div v-html="message"></div>
    </v-alert>
    <v-alert v-else :type="messageType" rounded dense class="a-message-sheet">
      {{ message }}
    </v-alert>
  </v-bottom-sheet>
</template>

<script>
import { MESSAGE_SHEET_TIMEOUT } from "@/utils/constant";
export default {
  name: "MessageSheet",
  props: {
    showMessage: { type: Boolean, default: false },
    message: String,
    messageType: String,
    isMeetingUpdatedMsgDeletedDoc: { type: Boolean, default: false },
  },
  data() {
    return {
      render: 0,
    };
  },
  methods: {
    close() {
      this.$emit("close");
    },
  },
  watch: {
    showMessage: {
      immediate: true,
      deep: true,
      handler(val) {
        this.render++;
        if (val && this.messageType === "success") {
          clearTimeout(this._autoCloseTimer);
          this._autoCloseTimer = setTimeout(() => {
            this.close();
          }, MESSAGE_SHEET_TIMEOUT);
        } else {
          clearTimeout(this._autoCloseTimer);
        }
      },
    },
  },
  beforeDestroy() {
    clearTimeout(this._autoCloseTimer);
  },
};
</script>

<style scoped>
.a-message-sheet.info {
  background-color: #dae4f2 !important;
  color: #1c60d5 !important;
}
.a-message-sheet.warning {
  background-color: #f2e6da !important;
  color: #c66825 !important;
}
.a-message-sheet.success {
  background-color: #daf2de !important;
  color: #357540 !important;
}

.a-message-sheet.error {
  background-color: #ffebeb !important;
  color: var(--v-accent-base) !important;
}
.a-message-sheet {
  /* display: flex !important; */
  flex-direction: row !important;
  align-items: center !important;
  padding: 20px !important;
  gap: 20px !important;
  /* height: 72px !important; */
  box-shadow: 0px 2px 2px rgba(0, 0, 0, 0.1) !important;
  border-radius: 8px 8px 0px 0px !important;
}

.a-message-sheet /deep/ .v-alert__content {
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  word-break: break-word !important;
}

.a-message-sheet.success /deep/ .v-icon {
  color: #357540 !important;
}
.a-message-sheet.warning /deep/ .v-icon {
  color: #c66825 !important;
}
.a-message-sheet.info /deep/ .v-icon {
  color: #1c60d5 !important;
}

.a-message-sheet.error /deep/ .v-icon {
  color: var(--v-accent-base) !important;
}

.a-message-sheet /deep/ .v-alert__icon.v-icon {
  font-size: 26px !important;
}
.messageSheet {
  font-weight: 700 !important;
  font-size: 16px !important;
  line-height: 24px !important;
  word-break: break-word !important;
}
</style>